export default __webpack_public_path__ + "static/media/Instruction3.e4f9e3df.png";